import React, { ReactElement, useMemo } from 'react';
import { Heading } from 'idsk-react-components';
import { UploadedFile } from 'slovlex-idsk-react-components';
import PrispevokVestnika from '../../../model/PrispevokVestnika';
import PrispevokVestnikaStepEnum from '../../../model/PrispevokVestnikaStepEnum';
import { handleDownloadPriloha } from '../../../function/handleDownloadPriloha';
import { useSecurityContext } from '../../../context/SecurityContext';

interface Props {
  prispevokVestnika: PrispevokVestnika;
  onChange: (nextStep: PrispevokVestnikaStepEnum) => Promise<void>;
}

const FilledAttachments4 = ({
  onChange,
  prispevokVestnika,
}: Props): ReactElement => {
  const hlavnaPriloha = useMemo(() => (prispevokVestnika.prilohy.length === 1
    ? prispevokVestnika.prilohy[0]
    : prispevokVestnika.prilohy.find(priloha => priloha?.hlavna === true)), [prispevokVestnika.prilohy]);
  const { accessToken, organizationId } = useSecurityContext();
  const headers = {
    ...(accessToken && { Authorization: `Bearer ${accessToken}` }),
    ...(organizationId && { OrganizationId: encodeURIComponent(organizationId) }),
  };

  return prispevokVestnika.prilohy?.length > 0 && (
    <>
      <Heading size="m">Prílohy</Heading>
      {hlavnaPriloha && (
        <>
          <Heading size="s">Hlavný dokument</Heading>
          <UploadedFile
            file={hlavnaPriloha.file}
            fileSize={hlavnaPriloha.fileSize}
            onDownload={!!hlavnaPriloha.file
            && (() => handleDownloadPriloha(hlavnaPriloha.uuid, hlavnaPriloha.originalFilename, { headers }))}
            onChange={() => {
              onChange(PrispevokVestnikaStepEnum.ATTACHMENTS_4);
            }}
            inputFilename={hlavnaPriloha.nazovSuboru}
          />
        </>
      )}
      {prispevokVestnika.prilohy?.length > 1 && (
        <>
          <Heading size="s">Ďalšie prílohy</Heading>
          {prispevokVestnika.prilohy
            .filter(priloha => !priloha.hlavna)
            .map((priloha, index) => (
              <UploadedFile
                /* eslint-disable-next-line react/no-array-index-key */
                key={index}
                file={priloha.file ? priloha.file : new File([''], priloha.originalFilename)}
                fileSize={priloha.fileSize}
                onDownload={!!priloha.file
                && (() => handleDownloadPriloha(priloha.uuid, priloha.originalFilename, { headers }))}
                onChange={() => {
                  onChange(PrispevokVestnikaStepEnum.ATTACHMENTS_4);
                }}
                inputFilename={priloha.nazovSuboru}
              />
            ))}
        </>
      )}
    </>
  );
};
export default FilledAttachments4;
